export default {
    methods: {
        gotoInvoice (p, target = '_blank') {
            let router = this.$router || this.router
            let routeData = router.resolve({name: 'financeiro.show', params: {id: p.id}})
            window.open(routeData.href, '_blank')
        }
    }
}
